import React, { FC } from 'react'
import _ from 'lodash'
// Components
import { field_attrs } from "components/table/lib/column-field"
import DropdownInput from "components/inputs/dropdown"
import NumberInput from "components/inputs/number"
// Data
import propertyService from "data/property"
// Styles
import { H4, Label_s } from "styles/app-styles"
import { Defaults_s } from "components/property/defaults/defaults-styles"

interface DefaultsMarketLeaseProps {
  property: object
  increaseData: object[]
  inflationData: object[]
  marketLeaseData: object[]
  payoutData: object[]
}

const DefaultsMarketLease: FC<DefaultsMarketLeaseProps> = (props) => {
  const { property, increaseData, inflationData, marketLeaseData, payoutData } = props;

  const persist = (field, val) => {
    const nextProperty = _.cloneDeep(property);
    let data = nextProperty['defaultsmarketlease'];
    _.set(data, field, val);
    propertyService.patch(nextProperty)
  }

  const namedItemPersist = (field, val) => {
    const nextProperty = _.cloneDeep(property);
    let data = nextProperty['defaultsmarketlease'];
    _.set(data, field, Number(val))
    propertyService.patch(nextProperty)
  }

  const data = property['defaultsmarketlease'] || {};

  const attrs = (field) => field_attrs('property', 'defaultsmarketlease')(field)(property, props)

  return property && !_.isEmpty(data) ? (
    <Defaults_s>
      <div>
        <H4>General</H4>
        <hr />
        <div>
          <div>
            <Label_s>Term</Label_s>
            <NumberInput
              field="term"
              value={data['term']}
              persist={persist}
            />
          </div>
          <div>
            <Label_s>Downtime</Label_s>
            <NumberInput
              field="downtime"
              value={data['downtime']}
              persist={persist}
            />
          </div>
          <div>
            <Label_s>Renewal Probability</Label_s>
            <NumberInput
              field="renewalProbability"
              value={data['renewalProbability']}
              persist={persist}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Revenue</H4>
        <hr />
        <div>
          <div>
            <Label_s>Rent: Amt Type</Label_s>
            <DropdownInput
              field="rentAmtType"
              options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr', '% of Market'].map(opt => { return { label: opt, value: opt }})}
              value={data['rentAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Rent: Increase</Label_s>
            <DropdownInput
              field="rentIncrease.increaseNamedItemId"
              options={increaseData.map(option => { return { label: option['code'], value: Number(option['increaseid']) }})}
              value={_.get(data, 'rentIncrease.increaseNamedItemId')}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Free Rent: Amt Type</Label_s>
            <DropdownInput
              field="freeRentAmtType"
              options={['Mos','Mos/Yr'].map(opt => { return { label: opt, value: opt }})}
              value={data['freeRentAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Free Rent: Revenue</Label_s>
            <DropdownInput
              field="freeRentRevenue"
              options={['Rent', 'Rent + Recovery', 'All Revenues'].map(opt => { return { label: opt, value: opt }})}
              value={data['freeRentRevenue']}
              persist={persist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Tenant Capital</H4>
        <hr />
        <div>
          <div>
            <Label_s>TI: Amt Type</Label_s>
            <DropdownInput
              field="tiAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ].map(opt => { return { label: opt, value: opt }})}
              value={data['tiAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>TI: Payout</Label_s>
            <DropdownInput
              field="tiPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['tiPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>LC: Amt Type</Label_s>
            <DropdownInput
              field="lcAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ].map(opt => { return { label: opt, value: opt }})}
              value={data['lcAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>LC: Payout</Label_s>
            <DropdownInput
              field="lcPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['lcPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Other Capital: Amt Type</Label_s>
            <DropdownInput
              field="ocAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ].map(opt => { return { label: opt, value: opt }})}
              value={data['ocAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Other Capital: Payout</Label_s>
            <DropdownInput
              field="ocPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['ocPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Retail</H4>
        <hr />
        <div>
          <div>
            <Label_s>Sales: Amt Type</Label_s>
            <DropdownInput
              field="salesAmtType"
              options={['/Area/Mo', '/Area/Yr']}
              value={data['salesAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Sales: Inflation</Label_s>
            <DropdownInput
              field="salesInflation.inflationNamedItemId"
              options={inflationData.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['salesInflation']['inflationNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
    </Defaults_s>
  ) : null
}

export default DefaultsMarketLease

